import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { validateAdminRegistration } from "utils/data/Login";
import NotifMessage from "components/common/tools/NotifMessage";
import OFormPasswordValidator from "components/common/form/OFormPasswordValidator";

import LangSelector from "components/utils/LangSelector";

import "css/admin/signup.scss";

export class SignupStep2UI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      first_name: "",
      last_name: "",
      organization: "",
      password: "",
      validation: {
        isValid: true,
        error: "",
      },
      showValidation: false,
      termChecked: false,
    };
  }

  onSignup = () => {
    this.setState({
      showValidation: true,
    });

    if (this.state.validation.isValid && this.state.termChecked) {
      this.props.onCreateUser(
        {
          email: this.state.email,
          first_name: this.state.first_name,
          last_name: this.state.last_name,
          organization: this.state.organization,
          password: this.state.password,
        },
        this.onCreateUserError,
      );
    }
  };

  onCreateUserError = (e) => {
    if (e && e.details) {
      this.setState({
        validation: {
          isValid: false,
          error: e.details.error,
        },
      });
    }
  };

  onChange = (target) => {
    this.setState({
      [target.id]: target.value,
    });
  };

  onBlur = () => {
    this.setState({
      validation: validateAdminRegistration(this.state),
    });
  };

  onTerm = (input) => {
    this.setState({
      termChecked: input.target.checked,
    });
  };

  render() {
    const { t, lang } = this.props;
    let validationComponent = null;

    if (!this.state.validation.isValid && this.state.showValidation)
      validationComponent = (
        <NotifMessage
          message={t(`error:${this.state.validation.error}`)}
          severity="error"
        />
      );

    if (
      !this.state.termChecked &&
      this.state.validation.isValid &&
      this.state.showValidation
    )
      validationComponent = (
        <NotifMessage
          message={t("error:errorValidationTerm")}
          severity="error"
        />
      );

    return (
      <div className="signup-step-container signup-step-form-container">
        <form className="signup-login-form">
          {validationComponent}
          <div className="form-row">
            <div className="signup-form-item">
              <div className="signup-form-item-title">{t("email")}</div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="material-icons">email</i>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    value={this.state.email}
                    placeholder={t("email")}
                    aria-label={t("email")}
                    aria-describedby="email"
                    onChange={(e) => {
                      this.onChange(e.target);
                    }}
                    onBlur={this.onBlur}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="signup-form-item">
              <div className="signup-form-item-title">{t("first_name")}</div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="material-icons">perm_identity</i>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="first_name"
                    value={this.state.first_name}
                    placeholder={t("first_name")}
                    aria-label={t("first_name")}
                    aria-describedby="first_name"
                    onChange={(e) => {
                      this.onChange(e.target);
                    }}
                    onBlur={this.onBlur}
                  />
                </div>
              </div>
            </div>
            <div className="signup-form-item">
              <div className="signup-form-item-title">{t("last_name")}</div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="material-icons">perm_identity</i>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="last_name"
                    value={this.state.last_name}
                    placeholder={t("last_name")}
                    aria-label={t("last_name")}
                    aria-describedby="last_name"
                    onChange={(e) => {
                      this.onChange(e.target);
                    }}
                    onBlur={this.onBlur}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="signup-form-item">
              <div className="signup-form-item-title">{t("organization")}</div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="material-icons">domain</i>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="organization"
                    value={this.state.organization}
                    placeholder={t("organization")}
                    aria-label={t("organization")}
                    aria-describedby="organization"
                    onChange={(e) => {
                      this.onChange(e.target);
                    }}
                    onBlur={this.onBlur}
                  />
                </div>
              </div>
            </div>
            <div className="signup-form-item">
              <div className="signup-form-item-title">{t("password")}</div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="material-icons">lock_open</i>
                  </div>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={this.state.password}
                    aria-label={t("password")}
                    placeholder={t("password")}
                    aria-describedby="password"
                    onChange={(e) => {
                      this.onChange(e.target);
                    }}
                    onBlur={this.onBlur}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="signup-form-item password-validator-container">
              {["min8", "lowercase", "uppercase", "digits"].map((rule, idx) => (
                <OFormPasswordValidator
                  key={idx}
                  password={this.state.password}
                  rule={rule}
                  namespace="admin-signup"
                />
              ))}
            </div>
          </div>
        </form>
        <div className="signup-btn-container">
          <div className="signup-term-container">
            <label className="signup-term">
              <span className="signup-term-link">
                {t("term_accept")}
                <a
                  target="_blank"
                  href={
                    lang === "en"
                      ? "https://okast.tv/terms/"
                      : "https://okast.tv/cgu/"
                  }
                  rel="noopener noreferrer"
                >
                  {t("term_privacy")}
                </a>
              </span>

              <input
                type="checkbox"
                onChange={this.onTerm}
                checked={this.state.termChecked}
                id="term"
                name="term"
                className="signup-term-checkbox"
              />
              <span className="signup-term-checkmark" />
            </label>
          </div>
          <div className="signup-btn-wrapper">
            <div className="signup-btn-confirm" onClick={this.onSignup}>
              <span>{t("btn_confirm_step2")}</span>
            </div>
            <LangSelector languages={["en", "fr"]} />
          </div>
        </div>
      </div>
    );
  }
}

SignupStep2UI.propTypes = {
  t: PropTypes.func.isRequired,
  onCreateUser: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    lang: state.variableReducer.lang,
  };
};

export default connect(mapStateToProps)(
  withTranslation("editor-signup", "error")(SignupStep2UI),
);
